import { COWORKING } from '@/types/spaceTypes.constants';

export const getFormattedPrice = (spaceInfo, lenguage, convert) => {
  if (!spaceInfo) return '';
  const usdIds = [154, 155, 156, 157, 158, 159, 160, 161, 162];
  const price =
    spaceInfo?.subtype_id === COWORKING ? spaceInfo?.rate_24_hours : spaceInfo?.hourly_rate;
  const transformPrice =
    lenguage === 'ES' || usdIds?.includes(Number(spaceInfo?.space_id)) ? price : convert(price);
  const formattedPrice = parseFloat(transformPrice).toFixed(2).replace(/\.00$/, '');
  const currency =
    lenguage !== 'ES' || usdIds?.includes(Number(spaceInfo?.space_id)) ? 'USD' : 'MXN';
  return `${formattedPrice} ${currency}`;
};

export const getFormattedPriceObject = (spaceInfo, lenguage, convert) => {
  if (!spaceInfo) return '';
  const usdIds = [154, 155, 156, 157, 158, 159, 160, 161, 162];
  const price =
    spaceInfo?.subtype_id === COWORKING ? spaceInfo?.rate_24_hours : spaceInfo?.hourly_rate;
  const transformPrice =
    lenguage === 'ES' || usdIds?.includes(Number(spaceInfo?.space_id)) ? price : convert(price);
  const calculatedPrice = parseFloat(transformPrice).toFixed(2).replace(/\.00$/, '');
  const currency =
    lenguage !== 'ES' || usdIds?.includes(Number(spaceInfo?.space_id)) ? 'USD' : 'MXN';
  return {
    calculatedPrice: calculatedPrice,
    currency: currency,
    formattedPrice: `${calculatedPrice} ${currency}`,
  };
};
